import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "./apiService";

// Support submissions require authentication (api-key header + Bearer token),
// so this must go through the token-aware apiCall, not apiCallWithoutToken.
export async function createSupportTicket(payload) {
  return await apiService.apiCall(
    endPoints.CREATE_SUPPORT_TICKET,
    "POST",
    payload
  );
}
